module.exports = __webpack_public_path__ + "img/nuxt.f86cafb3.jpg";